import { login } from '../auth.js';

export const splashScene = {
  async mount(root, ctx) {
    root.innerHTML = `
      <div class="splash">
        <div class="splash-sub">CABARET PRESENTS</div>
        <div class="logo">BEER CATCH<br/>PARTY</div>
        <div class="splash-tagline">CATCH · UNLOCK · COLLECT</div>
        <div class="loading">
          <span class="dot"></span><span class="dot"></span><span class="dot"></span>
          <span class="loading-text">Warming up</span>
        </div>
      </div>`;
    try {
      const { user } = await login();
      ctx.state.user = user;
      await ctx.goto('menu');
    } catch (e) {
      console.error('login failed', e);
      root.querySelector('.splash').innerHTML = `
        <div class="logo">BEER CATCH<br/>PARTY</div>
        <div class="error">Login failed: ${e.message || 'unknown'}<br/><br/>Check BE at ${import.meta.env.VITE_API_BASE}</div>`;
    }
  }
};
